/* eslint-disable react-hooks/exhaustive-deps */
import { forwardRef, useEffect, useState } from "react";
import DatePicker from "react-datepicker";
import { registerLocale } from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

import ptBR from "date-fns/locale/pt-BR";

import { useFilters } from "../../../providers/filters";
import { useDoctorsData } from "../../../providers/doctorsData";

import { StyledDatePicker } from "./styles";
import { useSearchParams } from "react-router-dom";

registerLocale("ptBR", ptBR);

interface IDatePickerProps {
  theme: "light" | "dark";
}

const DatePickerComponent = ({ theme }: IDatePickerProps) => {
  const [startDate, setStartDate] = useState<Date | null>(null);

  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get("date") && searchParams.get("date") != "") {
      const dataString =searchParams.get("date") || "";
      const data = new Date(dataString);
      const dataLocal = new Date(
        data.getUTCFullYear(),
        data.getUTCMonth(),
        data.getUTCDate()
      );
      setStartDate(dataLocal);
    }else{
      setStartDate(null);
    }
  }, [searchParams]);

  const CustomInput = forwardRef(({ value, onClick }: any, ref: any) => (
    <button
      className="btn btn-outline-secondary d-flex align-items-center"
      onClick={onClick}
      ref={ref}
    >
      <i className="las la-calendar"></i>
      <span className={`d-inline-block ps-2 ${value && 'pe-3'}`}>{value ? value : "Data da consulta"}</span>
    </button>
  ));

  return (
    <DatePicker
      placeholderText="Clique para escolher uma data"
      minDate={new Date()}
      dateFormat="dd/MM/yyyy"
      locale="ptBR"
      selected={startDate}
      isClearable
      closeOnScroll={true}
      onChange={(date: Date) => {
        debugger;
        if (date) {
          searchParams.set("date", date.toISOString().split("T")[0])
        } else{
          searchParams.delete("date")
        }
        setSearchParams(searchParams);
        setStartDate(date);
      }}
      customInput={<CustomInput />}
      tabIndex={1}
      fixedHeight
      // disabled={searching}
    />
  );
};

export { DatePickerComponent };
